// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bd34e988","455":"8187fe08","977":"4d8d4e87"}[chunkId] + ".chunk.js";
};